import { normalizeTag } from "src/hooks/useQuestionFilter";
import { HoverTag } from "./HoverTag";
import { SmallTitle } from "./ListPage";
import { Button } from "antd";
import { useState } from "react";

interface CollapsibleTagsProps {
  title: string;
  tags: string[];
  initialLimit?: number;
  activeFilters: Array<{ attribute: string; value: string }>;
  attribute: string;
  onTagClick: (tag: string) => void;
  colorPrimaryActive: string;
}

export function CollapsibleTags({
  title,
  tags,
  initialLimit = 10,
  activeFilters,
  attribute,
  onTagClick,
  colorPrimaryActive,
}: CollapsibleTagsProps) {
  const [showAll, setShowAll] = useState(false);
  const visibleTags = showAll ? tags : tags.slice(0, initialLimit);
  const hasMore = tags.length > initialLimit;

  return (
    <div style={{ marginTop: 16 }}>
      <SmallTitle text={`${title} (${tags.length})`} />
      {visibleTags.map((tag) => (
        <HoverTag
          key={tag}
          color={
            activeFilters.some(
              (filter) =>
                filter.attribute === attribute &&
                normalizeTag(filter.value) === normalizeTag(tag)
            )
              ? colorPrimaryActive
              : undefined
          }
          style={{
            marginBottom: 4,
            cursor: "pointer",
            textTransform: "capitalize",
          }}
          onClick={() => onTagClick(tag)}
        >
          {tag}
        </HoverTag>
      ))}
      {hasMore && !showAll && (
        <HoverTag
          style={{
            marginBottom: 4,
            cursor: "pointer",
            fontWeight: 600,
          }}
          onClick={() => setShowAll(true)}
        >
          {`+${tags.length - initialLimit} more`}
        </HoverTag>
      )}
      {showAll && (
        <Button
          type="link"
          size="small"
          onClick={() => setShowAll(false)}
          style={{
            padding: 0,
            height: "auto",
            marginTop: 4,
            fontSize: "12px",
          }}
        >
          Show Less
        </Button>
      )}
    </div>
  );
}
